import React from 'react'
import { Maybe } from 'graphql/jsutils/Maybe'
import { paths } from '@/constants/paths'
import { LegalLayout } from '@/layouts/LegalLayout'
import { NextPageWithLayout } from '@/layouts/types'
import { Page } from '@/page'
import { getPageByPath } from '@/services/CmsService/Pages'
import { PageDataContext, PageModel, fetchPageDataContext } from '@/services/RenderService'
import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { determinePageRevalidation } from '@/utils/nextUtils/revalidation'
import { getGenericStaticPaths } from '@/utils/nextUtils/staticPages'
import { loadTranslations } from '@/utils/translate/translate-server'

interface LegalIndexPageProps {
  pageDataContext: Maybe<PageDataContext>
  page: Maybe<PageModel>
}

const LegalIndexPage: NextPageWithLayout<LegalIndexPageProps> = (props) => {
  return (
    <div className="bg-white py-20 text-justify text-black">
      <main className="flex flex-col gap-8 p-10">
        <Page page={props.page} pageDataContext={props.pageDataContext} />
      </main>
    </div>
  )
}

LegalIndexPage.getLayout = (page: React.ReactElement) => {
  return <LegalLayout>{page}</LegalLayout>
}

export const getStaticProps = getStaticPropsErrorHandler<LegalIndexPageProps>(
  { filePath: 'pages/[locale]/legal/index.tsx' },
  async ({ locale, preview, federationClient }) => {
    const [page, translations] = await Promise.all([
      getPageByPath(paths.legal.index, { locale, preview }),
      loadTranslations(locale, ['common', 'account']),
    ])
    const pageDataContext = page ? await fetchPageDataContext(page, preview, locale, federationClient) : null

    return {
      props: {
        page,
        pageDataContext,
        ...translations,
      },
      revalidate: determinePageRevalidation(page, pageDataContext),
    }
  },
)

export const getStaticPaths = getGenericStaticPaths

export default LegalIndexPage
